module.exports = __webpack_public_path__ + "static/media/mas-wifi.8303e3ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/mas-wifi.svg
// module id = 159
// module chunks = 0